module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-50-min.1026dc6d.jpg";